import type { stacks } from "@dropbox/api-v2-client";
import type { ButtonProps } from "@dropbox/dig-components/buttons";
import { Button } from "@dropbox/dig-components/buttons";
import { createUxaElementId } from "@mirage/analytics/uxa";
import i18n from "@mirage/translations";

interface EditStackButtonProps {
  stack: stacks.Stack | null;
  onClick: () => void;
}

export const EditStackButton: React.FC<
  EditStackButtonProps & Partial<ButtonProps>
> = ({ stack, onClick, ...props }) => {
  return (
    <Button
      variant="opacity"
      data-testid="EditStack"
      onClick={onClick}
      data-uxa-log={createUxaElementId("edit_button", {
        actionSurfaceComponent: "stacks",
        featureLine: "stacks",
      })}
      data-uxa-entity-id={stack?.namespace_id ?? ""}
      aria-label={i18n.t("edit")}
      {...props}
    >
      {i18n.t("edit")}
    </Button>
  );
};
